import { REQUIRED_MESSAGE, requiredString } from '@wyz/utils';
import { z } from 'zod';

export const redistributionSupplierTemplateFormSchema = z.object({
  name: requiredString,
  customerScope: requiredString,
  criteria: z
    .array(
      z.object({
        criterion: z.object({ id: z.string() }),
        values: z.array(requiredString).min(1, { message: REQUIRED_MESSAGE }),
      }),
    )
    .min(1, { message: REQUIRED_MESSAGE }),
  suppliers: z
    .array(
      z.object({
        wyzApiId: z.number(),
        orderable: z.boolean().nullable(),
        customName: z.string().nullish(),
        type: z.number(),
        status: z.string(),
        customerId: z.string().nullish(),
      }),
    )
    .min(1, { message: REQUIRED_MESSAGE }),
});

export const redistributionSupplierTemplatePayload =
  redistributionSupplierTemplateFormSchema
    .omit({ criteria: true, customerScope: true })
    .extend({
      customerScope: z
        .array(
          z.object({
            id: z.string({
              error: (issue) =>
                issue.input === undefined ? REQUIRED_MESSAGE : undefined,
            }),
          }),
        )
        .min(1, REQUIRED_MESSAGE),
      criteria: z.array(
        z.object({
          criterion: z.object({ id: z.string() }),
          values: z.array(
            z.object({
              id: z.string(),
              label: z.string(),
            }),
          ),
        }),
      ),
    });
export const redistributionSupplierTemplateSchema =
  redistributionSupplierTemplateFormSchema
    .omit({ criteria: true, customerScope: true })
    .extend({
      id: z.string(),
      customerScope: z.array(
        z.object({
          id: z.string(),
        }),
      ),
      criteria: z.array(
        z.object({
          criterion: z.object({ id: z.string(), label: z.string() }),
          values: z.array(
            z.object({
              id: z.string(),
              label: z.string(),
            }),
          ),
        }),
      ),
    });
